import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from "react-router-dom";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@shopify/polaris/dist/styles.css';
import enTranslations from '@shopify/polaris/locales/en.json';
import {AppProvider} from '@shopify/polaris';
import logo from './assets/images/superlemon-logo_2x.png';

const theme = {
  logo: {
    width: 200,
    topBarSource: logo,
    contextualSaveBarSource: logo,
    accessibilityLabel: 'SuperLemon'
  }
};

ReactDOM.render(
  <AppProvider i18n={enTranslations} theme={theme}>
    <Router>
      <App />
    </Router>
  </AppProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
